import React from 'react';
import { useExperience } from '../experience/experience';

/**
 * The licence banner: only the owner and admins see it, and only when the licence from the vendor's office needs
 * attention (backend/entitlements/licence.py). In grace everything still works; after it, the paid add-ons are off
 * and the core (invoices, stock) keeps working. Staff never see it: their day is not interrupted by billing.
 */
const DATE = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' }) : '');

export default function LicenceBanner() {
  const exp = useExperience();
  const licence = exp?.licence;
  const roles = exp?.roles || [];
  if (!licence || !['grace', 'expired'].includes(licence.state)) return null;
  if (!roles.includes('org_owner') && !roles.includes('org_admin')) return null;

  const expired = licence.state === 'expired';
  return (
    <div role="status" data-testid="licence-banner"
      className={`px-4 py-2 text-sm text-center ${expired ? 'bg-red-50 text-red-800' : 'bg-amber-50 text-amber-900'}`}>
      {expired
        ? <>Your FoodOps licence ended on {DATE(licence.valid_until)}. Invoices and stock keep working; the extra features are
            switched off until it is renewed. Please contact your provider.</>
        : <>Your FoodOps licence ended on {DATE(licence.valid_until)}. Everything keeps working until {DATE(licence.grace_until)};
            please contact your provider to renew.</>}
    </div>
  );
}
